export default __webpack_public_path__ + "static/media/005-credit-card-01.7d17e71a.svg";